import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/images/logo-header.png"
      {...props}
    />
  );
};

export default Logo;
